import { internalFetch } from './fetchHelper';
import { getBackendApiUrl, getBackendApiKey } from './runtimeEnv';
import { apiCodeQuery, pagedQuery, toPaged } from './pagedCollection';
import type { IPagedCollection } from './interfaces/IPagedCollection';
import type {
  GetWorkAvailabilityWindowsParams,
  ICreateWorkAvailabilityWindowRequest,
  IUpdateWorkAvailabilityWindowRequest,
  IWorkAvailabilityWindow,
} from './interfaces/WorkInterfaces';

export const createWorkAvailabilityWindow = async (
  abortController: AbortController,
  data: ICreateWorkAvailabilityWindowRequest
): Promise<void> => {
  await internalFetch(
    `${getBackendApiUrl()}/p/workAvailabilityWindow`,
    'POST',
    abortController,
    JSON.stringify(data),
    true
  );
};

export const updateWorkAvailabilityWindow = async (
  abortController: AbortController,
  id: number,
  data: IUpdateWorkAvailabilityWindowRequest
): Promise<void> => {
  await internalFetch(
    `${getBackendApiUrl()}/p/workAvailabilityWindow?id=${id}`,
    'PUT',
    abortController,
    JSON.stringify(data),
    true
  );
};

export const deleteWorkAvailabilityWindow = async (
  abortController: AbortController,
  id: number
): Promise<void> => {
  await internalFetch(
    `${getBackendApiUrl()}/p/workAvailabilityWindow?id=${id}`,
    'DELETE',
    abortController,
    undefined,
    true
  );
};

export const getWorkAvailabilityWindow = async (
  abortController: AbortController,
  id: number
): Promise<IWorkAvailabilityWindow> => {
  return internalFetch(
    `${getBackendApiUrl()}/p/workAvailabilityWindow?id=${id}${apiCodeQuery(
      getBackendApiKey()
    )}`,
    'GET',
    abortController
  );
};

export const getWorkAvailabilityWindows = async (
  abortController: AbortController,
  workId: number,
  params: GetWorkAvailabilityWindowsParams
): Promise<IPagedCollection<IWorkAvailabilityWindow>> => {
  const result = await internalFetch(
    `${getBackendApiUrl()}/p/work/${workId}/workAvailabilityWindows?${pagedQuery(
      params,
      getBackendApiKey()
    )}`,
    'GET',
    abortController
  );
  return toPaged(result, params.pageSize, params.pageNo);
};
